var TranslationModel = /** @class */ (function () {
    function TranslationModel(variableName, minCoordinate, maxCoordinate, isProportion, minProportionScale, maxProportionScale, isReverseProportion, variableGroupName, dataSourceCode, variableVersion) {
        this.variableName = variableName;
        this.minCoordinate = minCoordinate;
        this.maxCoordinate = maxCoordinate;
        this.isProportion = isProportion;
        this.minProportionScale = minProportionScale;
        this.maxProportionScale = maxProportionScale;
        this.isReverseProportion = isReverseProportion;
        this.variableGroupName = variableGroupName;
        this.dataSourceCode = dataSourceCode;
        this.variableVersion = variableVersion;
    }
    return TranslationModel;
}());
export { TranslationModel };
